import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import {
  DcSensorValueProperties,
  Feature,
  FeatureNames,
  FeaturePropertyKey,
  HeatingBoilerPumpInternalProperties,
  HeatingValvuesFourThreeWayPositionProperties,
} from '@vi-iot/client';

import { InstallationFeaturesStore } from '@store';

import { FeaturesDetailsOverlayTypeEnum } from '../installation-overlay.model';
import { PillType } from '../../../shared/components/pill/pill.model';
import { INTERNAL_HYDRAULIC_SCHEDULE_LEVEL } from 'src/app/features/timemanager/schedule.enums';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-internal-hydraulic-features-panel',
  templateUrl: './internal-hydraulic-features-panel.component.html',
  styleUrls: ['./internal-hydraulic-features-panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InternalHydraulicFeaturesPanelComponent implements OnInit {
  readonly featurePropertyKey = FeaturePropertyKey;
  readonly pillType = PillType;
  readonly INTERNAL_HYDRAULIC_SCHEDULE_LEVEL = INTERNAL_HYDRAULIC_SCHEDULE_LEVEL;
  @Input() deviceId: string;

  getInternalHydraulicStatus$: Observable<Feature<HeatingBoilerPumpInternalProperties, never>>;
  internalHydraulicHeatingWaterVolumeFlow$: Observable<Feature<DcSensorValueProperties, never>>;
  internalHydraulicFourThreeWayValveActualPosition$: Observable<
    Feature<HeatingValvuesFourThreeWayPositionProperties, never>
  >;
  internalHydraulicCommonFlowTemperature$: Observable<Feature<DcSensorValueProperties, never>>;
  internalHydraulicReturnTemperature$: Observable<Feature<DcSensorValueProperties, never>>;

  availableOverlays = FeaturesDetailsOverlayTypeEnum;

  constructor(private installationFeaturesStore: InstallationFeaturesStore) {}

  ngOnInit(): void {
    this.getInternalHydraulicStatus$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.boilerPumpsInternal,
      this.deviceId
    );

    this.internalHydraulicHeatingWaterVolumeFlow$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.volumetricFlowReturn,
      this.deviceId
    );

    this.internalHydraulicFourThreeWayValveActualPosition$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.secondaryValvesFourThreeWayPosition,
      this.deviceId
    );

    this.internalHydraulicCommonFlowTemperature$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.boilerCommonSupplyTemperature,
      this.deviceId
    );

    this.internalHydraulicReturnTemperature$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.returnFlowTemperature,
      this.deviceId
    );
  }
}
